import Vue from "vue";
import i18n from "../../../i18n";

export default {
  async createSoil({ commit }, payload) {
    return Vue.axios.post(Vue.$url("soil"), payload).then((rsp) => {
      Vue.$log.debug("soil created and saved under", rsp.data.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Soil", 1: payload.description }), { root: true });
    });
  },

  async fetchSoils({ commit }, { pId, vId, pvId = null, active = -1 }) {
    Vue.$log.debug("loading soils for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "") + "&pvId=" + (pvId || "") + "&isDel=" + (active == -1 ? "" : !active);
    return Vue.axios.get(Vue.$url("soil" + query)).then((rsp) => commit("SET_SOILS", rsp.data));
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug("loading soil next code for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "");
    return Vue.axios.get(Vue.$url("soil/max-code" + query)).then((rsp) => {
      commit("SET_NEXT_SEQ_CODE", rsp.data);
      return rsp.data;
    });
  },

  async deleteSoil({ commit }, payload) {
    Vue.$log.debug("trying to delete Soil", payload.id);
    return Vue.axios.delete(Vue.$url("soil/" + payload.id)).then(() => {
      commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.description }), { root: true });
    });
  },

  async updateSoil({ commit }, payload) {
    return Vue.axios.put(Vue.$url("soil/" + payload.id), payload).then(() => {
      commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Soil", 1: payload.description }), { root: true });
    });
  },

  async updateSoilList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("pvId", payload.pvId);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`soil/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.upload"), { root: true });
        return rsp.data;
      });
  },
};
